import safeStorage from '../../../utils/safeStorage';

/**
 * Helpers for personal / Hunts-page enamel log sheet (4-step).
 */

export function mapClubsToStandOptions(clubs) {
  const stands = [];
  (Array.isArray(clubs) ? clubs : []).forEach((club) => {
    (club.hunt_locations || []).forEach((loc) => {
      if (!loc?.id) return;
      stands.push({
        id: loc.id,
        name: loc.name || `Stand ${loc.id}`,
        clubId: club.id,
        clubName: club.name || `Club ${club.id}`,
        geojson: loc.geojson || null,
      });
    });
  });
  return stands.sort((a, b) =>
    a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
  );
}

export function isWhereStepReady({ date, ground, locationName, huntLocationId, timePeriods }) {
  if (!date || !Array.isArray(timePeriods) || timePeriods.length === 0) return false;
  if (ground === 'club') return huntLocationId != null;
  return Boolean(String(locationName || '').trim());
}

export function buildPersonalLogPayload({
  date,
  timePeriods,
  ground,
  locationName,
  clubId,
  huntLocationId,
  saw,
  harvest,
  weight,
  points,
  notes,
  weatherData = {},
}) {
  const hasHarvest = harvest === 'buck' || harvest === 'doe';
  const isClub = ground === 'club';
  const payload = {
    date,
    time_periods: (timePeriods || []).map((p) => String(p).toLowerCase()),
    location: String(locationName || '').trim() || (isClub ? 'Club stand' : 'Private Spot'),
    location_type: isClub ? 'club_location' : 'private_spot',
    club_id: isClub && clubId != null ? Number(clubId) : null,
    hunt_location_id: isClub && huntLocationId != null ? Number(huntLocationId) : null,
    does_seen: Number(saw?.Does) || 0,
    bucks_seen: Number(saw?.Bucks) || 0,
    fawns_seen: Number(saw?.Fawns) || 0,
    shot_taken: hasHarvest,
    harvest: hasHarvest,
    notes: notes || '',
    weather_data: weatherData || {},
  };

  if (hasHarvest) {
    payload.harvest_details = {
      deer_type: harvest,
      method: 'gun',
      weight: weight ? parseFloat(weight) : null,
      points: harvest === 'buck' && points !== '' && points != null ? parseInt(points, 10) : null,
      notable_features: '',
    };
  }

  return payload;
}

export function resolvePersonalLogCoordinates({ ground, standGeojson }) {
  if (ground === 'club' && standGeojson?.type === 'Point' && Array.isArray(standGeojson.coordinates)) {
    return { lng: standGeojson.coordinates[0], lat: standGeojson.coordinates[1] };
  }
  try {
    const mapState = safeStorage.getItem('mapState');
    if (mapState) {
      const parsed = JSON.parse(mapState);
      if (parsed.center && parsed.center.length === 2) {
        return { lng: parsed.center[0], lat: parsed.center[1] };
      }
    }
  } catch (_) {}
  return null;
}

export function togglePeriod(periods, period) {
  const list = Array.isArray(periods) ? periods : [];
  const p = String(period).toLowerCase();
  return list.includes(p) ? list.filter((x) => x !== p) : [...list, p];
}
